var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowLightgrayMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74992 0.250001C10.1015 0.250001 10.414 0.367188 10.6484 0.601563L18.1484 8.10156C18.6562 8.57031 18.6562 9.39063 18.1484 9.85938C17.6796 10.3672 16.8593 10.3672 16.3905 9.85938L9.74992 3.25781L3.14836 9.85938C2.67961 10.3672 1.8593 10.3672 1.39055 9.85938C0.882737 9.39063 0.882737 8.57031 1.39055 8.10156L8.89055 0.601564C9.12492 0.367189 9.43742 0.250001 9.74992 0.250001Z",
    fill: "var(--lightgray-medium)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowLightgrayMedium);
export default __webpack_public_path__ + "static/media/down-arrow-lightgray-medium.e60eeba639c0807cf245e40b4fc2db1e.svg";
export { ForwardRef as ReactComponent };